<template>
  <section
    v-if="variants.v1 === variant"
    class="n-section-primary tw-overflow-hidden"
    :style="`background-color: var(--c-${vars.backgroundColor});color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <BlockSymbol
      v-if="vars.watermarkImage"
      :block-logo-image="String(vars.watermarkImage)"
      :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
      position-text="right_bottom"
      :company-key="company.company_key"
    />
    <BlockSymbol
      v-if="vars.watermarkImage"
      :block-logo-image="String(vars.watermarkImage)"
      :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
      position-text="left_top"
      :company-key="company.company_key"
    />
    <div class="tw-z-10 tw-mb-12 tw-flex tw-flex-col tw-gap-3 tw-self-center tw-text-center">
      <small v-if="vars.altTitleText">{{ vars.altTitleText }}</small>
      <h2>{{ vars.titleText }}</h2>
    </div>
    <div
      class="tw-z-10 tw-flex tw-h-full tw-w-full tw-flex-col tw-items-stretch tw-justify-center tw-gap-10 lg:tw-flex-row lg:tw-items-stretch"
    >
      <div
        v-for="card in cards"
        class="tw-flex tw-max-w-[600px] tw-flex-col tw-items-start tw-bg-white tw-p-7 lg:tw-max-w-none lg:tw-self-stretch"
        style="border-radius: var(--rounded)"
      >
        <h3 class="tw-mb-5 tw-uppercase">{{ card.title }}</h3>
        <p>{{ card.description }}</p>
        <div class="tw-mt-4 tw-flex tw-items-center tw-gap-2">
          <span
            ><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.8395 5.06984C7.47244 3.43691 9.68718 2.51953 11.9965 2.51953C14.3058 2.51953 16.5206 3.43691 18.1535 5.06984C19.7864 6.70278 20.7038 8.91752 20.7038 11.2268C20.7038 13.5362 19.7864 15.7509 18.1535 17.3838L16.9665 18.5578C16.0918 19.4158 14.9565 20.5198 13.5605 21.8698C13.1409 22.2755 12.5801 22.5023 11.9965 22.5023C11.4129 22.5023 10.8521 22.2755 10.4325 21.8698L6.94151 18.4738C6.50217 18.0432 6.13484 17.6798 5.8395 17.3838C5.03092 16.5753 4.38951 15.6154 3.9519 14.559C3.5143 13.5026 3.28906 12.3703 3.28906 11.2268C3.28906 10.0834 3.5143 8.9511 3.9519 7.89468C4.38951 6.83825 5.03092 5.87837 5.8395 5.06984ZM17.0925 6.12984C16.4232 5.46056 15.6285 4.92967 14.754 4.56748C13.8795 4.2053 12.9422 4.0189 11.9957 4.01895C11.0491 4.019 10.1118 4.20548 9.23734 4.56775C8.36285 4.93003 7.56829 5.461 6.899 6.13034C6.22972 6.79969 5.69883 7.59431 5.33664 8.46883C4.97446 9.34335 4.78807 10.2806 4.78811 11.2272C4.78816 12.1738 4.97464 13.111 5.33692 13.9855C5.69919 14.86 6.23016 15.6546 6.8995 16.3238L8.3875 17.7918C9.20617 18.5925 10.2355 19.5925 11.4755 20.7918C11.6153 20.9269 11.8021 21.0023 11.9965 21.0023C12.1909 21.0023 12.3777 20.9269 12.5175 20.7918L15.9125 17.4918C16.3825 17.0312 16.7758 16.6418 17.0925 16.3238C18.444 14.9723 19.2033 13.1392 19.2033 11.2278C19.2033 9.31649 18.444 7.48341 17.0925 6.13184M11.9965 8.50084C12.3907 8.50084 12.7811 8.57849 13.1453 8.72936C13.5095 8.88022 13.8405 9.10135 14.1192 9.38011C14.398 9.65887 14.6191 9.98981 14.77 10.354C14.9209 10.7182 14.9985 11.1086 14.9985 11.5028C14.9985 11.8971 14.9209 12.2874 14.77 12.6517C14.6191 13.0159 14.398 13.3468 14.1192 13.6256C13.8405 13.9043 13.5095 14.1255 13.1453 14.2763C12.7811 14.4272 12.3907 14.5048 11.9965 14.5048C11.2099 14.4905 10.4605 14.1679 9.90928 13.6066C9.3581 13.0453 9.04929 12.29 9.04929 11.5033C9.04929 10.7167 9.3581 9.9614 9.90928 9.40007C10.4605 8.83874 11.2099 8.5162 11.9965 8.50184M11.9965 10.0018C11.5981 10.0018 11.2161 10.1601 10.9344 10.4418C10.6528 10.7234 10.4945 11.1055 10.4945 11.5038C10.4945 11.9022 10.6528 12.2842 10.9344 12.5659C11.2161 12.8476 11.5981 13.0058 11.9965 13.0058C12.388 12.9957 12.7601 12.8331 13.0334 12.5526C13.3068 12.2721 13.4598 11.896 13.4598 11.5043C13.4598 11.1127 13.3068 10.7365 13.0334 10.4561C12.7601 10.1756 12.388 10.0129 11.9965 10.0028"
                fill="black"
              />
            </svg>
          </span>
          <h6 class="tw-uppercase">{{ card.location }}</h6>
        </div>
        <div class="tw-mb-6 tw-mt-6 tw-flex tw-flex-wrap tw-items-center tw-gap-3">
          <div
            v-if="card.feature1"
            class="tw-p-3"
            style="background-color: var(--c-section_secondary); border-radius: var(--rounded)"
          >
            <h6 class="tw-uppercase">{{ card.feature1 }}</h6>
          </div>
          <div
            v-if="card.feature2"
            class="tw-p-3"
            style="background-color: var(--c-section_secondary); border-radius: var(--rounded)"
          >
            <h6 class="tw-uppercase">{{ card.feature2 }}</h6>
          </div>
          <div
            v-if="card.feature3"
            class="tw-p-3"
            style="background-color: var(--c-section_secondary); border-radius: var(--rounded)"
          >
            <h6 class="tw-uppercase">{{ card.feature3 }}</h6>
          </div>
        </div>
        <nuxt-link :to="card.link" :external="true" class="n-primary outlined tw-mt-auto">{{
          card.button_label
        }}</nuxt-link>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'Jobs',

  mixins: [ComponentMixin],

  components: {
    BlockSymbol,
  },

  data() {
    return {
      variants: { v1: 'v1' },
    };
  },
  computed: {
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>
